import { useProjectStateData } from './useProjectStateData';

export const useNavigationInfo = (projectId, stateId = 'default') =>
  useProjectStateData(projectId, stateId, 'navigationInfo');
